/**
 * Akkordeon-Deep-Links: #c10221 öffnet den Eintrag (auch verschachtelt, auch im Tab)
 * und scrollt hin. Beim Aufklappen wird die Adresse aktualisiert, damit man
 * den Link teilen kann (ohne neuen Verlaufseintrag).
 */
export function initDeepLinks() {
  const reveal = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    // alle umgebenden <details> öffnen
    let el = target;
    while (el) {
      if (el.tagName === 'DETAILS') el.open = true;
      el = el.parentElement;
    }
    target.closest('[data-tabs]')?.dispatchEvent(new CustomEvent('tabs:reveal', { detail: target }));
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
  };
  reveal();
  window.addEventListener('hashchange', reveal);

  document.querySelectorAll('details.c-accordion__item[id]').forEach((item) => {
    item.addEventListener('toggle', () => {
      /* print.js öffnet vor dem Druck alle Akkordeons, das ist kein Anspringen */
      if (item.open && !('printing' in document.documentElement.dataset)) history.replaceState(null, '', `#${item.id}`);
    });
  });
}
